import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetPersonnelRoleSummariesByDepartmentIdRequest,
    GetPersonnelRoleSummariesResponse,
    type IReturn,
    type PersonnelRoleSummary,
    type ResponseStatus,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetPersonnelRoleSummariesResponse, GetPersonnelRoleSummariesResponse>,
) => response?.data?.personnelRoleSummaries;
const getError = (
    response?: SWRResponse<GetPersonnelRoleSummariesResponse, GetPersonnelRoleSummariesResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = () => ({});

const usePersonnelRoleSummariesByDepartmentId = (
    departmentId?: number | null,
    configuration?: SWRConfiguration<
        GetPersonnelRoleSummariesResponse,
        GetPersonnelRoleSummariesResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!departmentId) return undefined;

        return (): IReturn<GetPersonnelRoleSummariesResponse> =>
            new GetPersonnelRoleSummariesByDepartmentIdRequest({ departmentId });
    }, [departmentId]);

    return useApi<
        GetPersonnelRoleSummariesResponse,
        PersonnelRoleSummary[],
        ResponseStatus,
        Record<string, never>
    >("get", getRequest, { getData, getError, getAdditionalState }, configuration ?? undefined);
};

export default usePersonnelRoleSummariesByDepartmentId;
